import {deepClone} from "../../../utils/format";


//树设置title
export function setTitle(data) {
  data.forEach(ele => {
    ele['title'] = ele.text;
    if (ele.children) {
      setTitle(ele.children)

    }
  })
}

//树设置title checked and level
export function setTitleCheckedAndLevel(data, index) {
  data.forEach(ele => {
    ele['title'] = ele.text;
    ele['level'] = index;
    ele['checked'] = false;
    if (ele.children) {
      // ele['expand'] = true
      let chilLevel = ele.level + 1;
      setTitleCheckedAndLevel(ele.children, chilLevel)
    }
  })
}

//树设置title selected and level
export function setTitleSelectedAndLevel(data, index) {
  data.forEach(ele => {
    ele['title'] = ele.text;
    ele['level'] = index;
    ele['selected'] = false;
    if (ele.children) {
      // ele['expand'] = true
      let chilLevel = ele.level + 1;
      setTitleSelectedAndLevel(ele.children, chilLevel)
    }
  })
}

//树设置title  and selected
export function setTitleAndSelected(data) {
  data.forEach(ele => {
    ele['title'] = ele.text;
    ele['selected'] = false;
    if (ele.children) {
      // ele['expand'] = true
      setTitleAndSelected(ele.children)
    }
  })


}

//根据data 设置tree 的选中状态  多选 只选中叶子节点
export function setCheckedFromData(tree, data) {
  tree.forEach(ele => {
    if (!ele.children || ele.children.length === 0) {
      if (data.indexOf(ele.value) !== -1) {
        ele['checked'] = true
      }
    }
    if (ele.children) {
      setCheckedFromData(ele.children, data)
    }
  })
}


//树搜索
export function filterArr(arr, searchText) {
  let ret = [];
  arr.forEach(function (ele) {
    ele['selected'] = false;
    if (!ele.children) {
      ele.title.indexOf(searchText) !== -1 && (ret.push(ele))
    }
    else {
      // let i = deepClone(ele)
      if (ele.title.indexOf(searchText) !== -1) {
        ele.expand = true;
        ret.push(ele)

      }
      else {
        let i = deepClone(ele);
        i.children = filterArr(ele.children, searchText);
        i.children.length > 0 && (i.expand = true);
        i.children.length > 0 && ret.push(i)
      }
    }
  });
  return ret
}


//设置默认选中项
export function setFirstSelected(data) {
  if (data && data.length > 0) {
    data[0]['selected'] = true
  }
}


//设置选中状态
export function setChecked(data, arr) {

  if (!data.length) {
    return
  }
  data.forEach(ele => {
    ele['checked'] = false;
    arr.forEach(ele1 => {
      if (ele.id + '' === ele1 + '') {
        ele['checked'] = true
      }
    });
    if (ele.children) {
      setChecked(ele.children, arr)
    }
  })
}


//
// export function setTitleAndOthers(data) {
//   data.forEach(ele=>{
//     ele['title']=ele.text
//     ele['checked']=false
//     ele['selected']=false
//
//     if(ele.children){
//       ele['expand']=true
//       setTitleAndOthers(ele.children)
//     }
//   })
// }

//树设置title、selected  and checked    非递归
export function setTitleAndOthers(data) {
  let arr = [];
  if (data && data.length) {
    arr.push(data)
    data[0]['expand']=true

  }

  while (arr.length !== 0) {
    let tem = arr.pop();
    tem.forEach(ele => {
      ele['title'] = ele.text;
      ele['checked'] = false;
      ele['selected'] = false;
      if (ele.children && ele.children.length > 0) {
        // ele['expand'] = true
        arr.push(ele.children)
      }
    })
  }
}
//table设置选中状态
export function setTableChecked(dataTable, idList) {
  dataTable.forEach(ele => {
    ele['_checked'] = false;
    if (idList.indexOf(ele.id+'') !== -1) {
      ele['_checked'] = true
    }
  })
}

export function setSelectedFromData(tree, data) {
  tree.forEach(ele => {
    if (data.indexOf(ele.value) !== -1) {
      ele['selected'] = true
    }
    if (ele.children) {
      setSelectedFromData(ele.children, data)
    }
  })
}


